import { AxiosResponse } from "axios";
import { API, PaginatedResponse } from "./api";

export type EmailTemplateActions =
  | "GET_EMAIL_TEMPLATES"
  | "SEND_EMAIL";

export interface EmailTemplate {
  id: string;
  name: string;
  body: string;
  dynamic_fields: string;
  subject: string;
  language: "sv" | "en";
}

export const getEmailTemplates = async (
  params?: Record<string, unknown>
): Promise<AxiosResponse<PaginatedResponse<EmailTemplate[]>>> => {
  return API.get(`/events/templates/`, { params });
};

export const sendEmail = async (
  recipients: string[],
  subject: string,
  body: string
): Promise<AxiosResponse<void>> => {
  return API.post(`/events/send_mail_to_users/`, { recipients, subject, body });
};

